<template>
  <b-modal
    :title="'Copiar rol Rol'"
    ref="modalEditionRol"
    hide-footer
    centered
  >
    <b-overlay :show="isSaving">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="nombre">Nombre</label>
            <input
              type="text"
              class="form-control"
              id="nombre"
              v-model="rol.name"
              placeholder="Nombre del rol"
            >
          </div>
        </div>
        <div class="col-md-12">
          <button
            class="btn btn-primary"
            @click="saveRol"
            :disabled="!isValid"
          >
            Guardar
          </button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import { ioCopiarCompanyRolPermission } from '@/febos/servicios/api/empresas.api';

export default {
  name: 'RolCopyModal',
  data() {
    return {
      isSaving: false,
      rol: {
        rolId: undefined,
        name: ''
      },
      creating: true
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    isValid() {
      return !!(
        this.rol.name
      );
    }
  },
  methods: {
    async saveRol() {
      this.isSaving = true;
      const { rol } = this;
      try {
        await ioCopiarCompanyRolPermission(this.company.id, rol.rolId, rol.name);
        this.$emit('saveRol', this.rol);
        this.$refs.modalEditionRol.hide();
        this.isSaving = false;
      } catch (e) {
        console.error(e);
        this.isSaving = false;
      }
    },
    open(rol) {
      this.rol = {
        rolId: rol.rolId,
        name: `${rol.nombre } (Copia)`
      };
      this.$refs.modalEditionRol.show();
    },
    hide() {
      this.$refs.modalEditionRol.hide();
    }
  }
};
</script>

<style scoped>

</style>
